import { useTheme } from 'styled-components';

import { RecurrentPayIcon } from '../../../../../assets/svg/payment-links-types/RecurrentPay';
import { UniquePayIcon } from '../../../../../assets/svg/payment-links-types/UniquePay';
import { SelectIcon } from '../../../../../assets/svg/SelectIcon';
import {
	ComingSoonContainer,
	IconContainer,
	PaymentTypeContainer,
	PaymentTypeSubTitle,
	PaymentTypeTitle,
	SelectedIconContainer,
} from '../styles';

interface PaymentTypeProps {
	isDisabled?: boolean;
	comingSoon?: boolean;
	type?: 'unique' | 'recurrent';
	title: string;
	subtitle: string;
	isSelected?: boolean;
	onClick?: () => void;
}

const PaymentType = ({
	isDisabled = false,
	comingSoon = false,
	type,
	title,
	subtitle,
	isSelected = false,
	onClick,
}: PaymentTypeProps) => {
	const { colors } = useTheme();
	return (
		<PaymentTypeContainer isDisabled={isDisabled} isSelected={isSelected} onClick={onClick}>
			<SelectedIconContainer>
				{isDisabled && comingSoon ? (
					<ComingSoonContainer>Próximamente</ComingSoonContainer>
				) : !isSelected ? null : (
					<SelectIcon />
				)}
			</SelectedIconContainer>

			<IconContainer isSelected={isSelected} show={!isDisabled || !comingSoon}>
				{isDisabled && comingSoon ? null : type === 'unique' ? (
					<UniquePayIcon disabled={!isSelected} />
				) : (
					<RecurrentPayIcon disabled={!isSelected} />
				)}
			</IconContainer>

			<PaymentTypeTitle isSelected={isSelected}>{title}</PaymentTypeTitle>
			<PaymentTypeSubTitle isSelected={isSelected}>{subtitle}</PaymentTypeSubTitle>
		</PaymentTypeContainer>
	);
};

export { PaymentType };
